var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOfflineBolt = function SvgOfflineBolt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "offline_bolt_svg__a",
    width: 19,
    height: 19,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h19v19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#offline_bolt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M9.499 17.02a7.3 7.3 0 0 1-2.934-.592 7.6 7.6 0 0 1-2.388-1.607 7.6 7.6 0 0 1-1.608-2.388 7.3 7.3 0 0 1-.592-2.932q0-1.56.592-2.934A7.6 7.6 0 0 1 4.176 4.18a7.6 7.6 0 0 1 2.387-1.608 7.3 7.3 0 0 1 2.933-.592q1.56 0 2.933.592 1.373.591 2.389 1.607a7.6 7.6 0 0 1 1.608 2.387 7.3 7.3 0 0 1 .592 2.933q0 1.56-.592 2.933a7.6 7.6 0 0 1-1.607 2.389 7.6 7.6 0 0 1-2.388 1.608 7.3 7.3 0 0 1-2.932.592m-.002-1.187q2.652 0 4.493-1.841 1.84-1.84 1.84-4.493 0-2.652-1.84-4.492T9.497 3.166t-4.492 1.84Q3.165 6.849 3.164 9.5t1.84 4.493q1.842 1.84 4.493 1.84m-.277-5.344v2.894q0 .264.248.318.247.053.36-.178l1.968-4.485a.37.37 0 0 0-.028-.355.33.33 0 0 0-.298-.173H9.893V5.553q0-.263-.247-.323t-.36.17l-2.06 4.56q-.076.195.021.362a.32.32 0 0 0 .293.167z"
  }))));
};
export default SvgOfflineBolt;